import { connect } from 'react-redux';
import { editReviewSection, cancelEditReviewSection } from 'pap/ducks/workflow';
import EditableSection from 'project/components/brief/editable_section';

const mapStateToProps = (state) => {
  return {
    user: state.user.profile_data,
    editingPapSection: state.pap.workflow.editReviewSection,
    attachments: state.pap.project.attachments,
    customContract: state.contract.customContracts.find((c) => c.type == 'ica')
  }
}

export default connect(mapStateToProps, {
  editPapSection: editReviewSection,
  cancelEditPapSection: cancelEditReviewSection
})(EditableSection);



// WEBPACK FOOTER //
// ./project/containers/brief_editable_section.jsx